import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { UiDisplayTagService } from "@vp/shared/store/ui";

@Component({
  selector: "vp-bottom-nav-copyright",
  standalone: false,
  templateUrl: "./bottom-nav-copyright.component.html",
  styleUrl: "./bottom-nav-copyright.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BottomNavCopyrightComponent {
  @Input() appCopyright!: string;

  constructor(public readonly uiDisplayTagService: UiDisplayTagService) {}
}
